import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AppButton, AuthSessionWrapper } from '@/components'
import { BaseText } from '@/components/base'
import { VideoAnimation } from '@/components/VideoAnimation'

import {
  responsiveAdapter,
  responsiveAdapterVertical,
} from '@/utils/responsive'
import SafeAreaLayout from '@/components/layout/SafeAreaLayout'

export const MainScreen: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AuthSessionWrapper>
      <div
        style={{
          padding: `${responsiveAdapter(12)}px`,
          paddingBottom: `${responsiveAdapter(12)}px`,
          position: 'relative',
          overflow: 'hidden',
        }}
        className="flex flex-col h-full items-end justify-end bg-[#000000]"
      >
        <SafeAreaLayout isStretch>
          {/* Coin spiral - exactly as in original */}
          <VideoAnimation />

          {/* Content at bottom of screen - exactly as in React Native */}
          <div
            style={{
              marginTop: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: `${responsiveAdapterVertical(44)}px`,
              zIndex: 1,
              position: 'relative',
            }}
            className="w-full h-full items-end justify-end"
          >
            {/* Text block */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: `${responsiveAdapterVertical(16)}px`,
                paddingTop: `${responsiveAdapterVertical(24)}px`,
              }}
            >
              {/* "welcome to kem" - small text */}
              <BaseText
                textAlign="center"
                color="label.default"
                fontSize={responsiveAdapter(16)}
                fontFamily="regular"
                style={{
                  textTransform: 'lowercase',
                  letterSpacing: '0.5px',
                  fontSize: `${responsiveAdapter(16)}px`,
                  color: '#F2F2F2', // White color as in React Native version
                }}
              >
                {t('screens:main.title')}
              </BaseText>

              <BaseText
                textAlign="center"
                color="label.default"
                fontSize={responsiveAdapter(30)}
                fontFamily="bold"
                style={{
                  lineHeight: `${responsiveAdapterVertical(36)}px`,
                  maxWidth: `${responsiveAdapter(320)}px`,
                  letterSpacing: '0.3px',
                }}
              >
                {t('screens:main.description')}
              </BaseText>
            </div>

            {/* "Get Started" button */}
            <AppButton
              label={t('form:actions.getStarted')}
              type="secondaryGrayDark"
              onClick={() => navigate('/auth/identification-method')}
              style={{
                marginBottom: `20px`,
                borderRadius: '16px',
                width: '100%',
                maxWidth: `${responsiveAdapter(320)}px`,
              }}
            />
          </div>
        </SafeAreaLayout>
      </div>
    </AuthSessionWrapper>
  )
}
